import {BlastSite as _BlastSite} from '../../../shared-models/public/blast-site';

export class BlastSite extends _BlastSite{
}

export namespace BlastSite{
	export import RestTypes=_BlastSite.RestTypes;
}